<mat-dialog-content class="pick-completion-dialog">
    <fieldset>
        <!-- Adjust Remaining Stock -->
        <inventory-adjustment-editor #pickAdjustmentQtyEditor [inventory]="source" (onEnterKey)="onAdjustmentEnterKey()"
            [OnHandLabel]="source.stockItem.isLotSerItem ? 'Roll Balance' : 'On Hand'"
            [required]="source.rolloutRequired"></inventory-adjustment-editor>
        <hr />

        <!-- Print Tags & Labels in expansion panel when needing Restock -->
        <mat-expansion-panel #PrinterExpansionPanel *ngIf="needPieceRestock"
            (opened)="setFocusToElement(PrinterSelectorInput)"
            [disabled]="source.rolloutRequired && !source.hasAdjustment">
            <mat-expansion-panel-header>
                <mat-panel-title>Print Tags & Labels</mat-panel-title>
            </mat-expansion-panel-header>

            <ng-template [ngTemplateOutlet]="PrinterSelectionInput"></ng-template>
        </mat-expansion-panel>

        <!-- Print Tags & Labels directly present when not needing Restock -->
        <div *ngIf="!needPieceRestock">
            <h3>Print Tags & Labels</h3>
            <ng-template [ngTemplateOutlet]="PrinterSelectionInput"></ng-template>
        </div>

        <!-- Restock -->
        <inventory-location-editor #RestockLocationComponent *ngIf="needPieceRestock" [inventory]="source"
            [warehouseLocations]="warehouseLocations" [allowReuse]="canReusePiece"
            (onLocationEntered)="onRestockBinScanned()" (onReusePiece)="dialogRef.close('reusePiece')"
            [disabled]="(source.rolloutRequired && source.AdjustRemainderTo === null) || (!source.AdjustmentAcceptable)"></inventory-location-editor>

        <div class="input-row">
            <button mat-raised-button matSuffix color="accent"
                mat-dialog-close="editAllocation"><mat-icon>edit</mat-icon></button>

            <span>&nbsp;</span>

            <span *ngIf="!needPieceRestock">
                <button mat-raised-button matSuffix (click)="closeDialog()">No Labels</button>
            </span>
        </div>
    </fieldset>
</mat-dialog-content>

<ng-template #PrinterSelectionInput>
    <div class="input-row">
        <label style="padding-left:0.5em;">Table:</label>&nbsp;

        <mat-form-field appearance="fill">
            <mat-label>Scan Printer</mat-label>
            <input #PrinterSelector [(ngModel)]="printerID" scanInput="PTR" type="text" matInput
                [matAutocomplete]="printerSelectAutocomplete" (scanned)="onTablePrinterScanned($event)">
            <mat-autocomplete #printerSelectAutocomplete="matAutocomplete">
                <mat-option *ngFor="let printer of settings.WarehousePrinters" [value]="printer.id">
                    {{printer.id}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <span>&nbsp;</span>

        <button mat-raised-button matSuffix color="accent" (click)="onTablePrinterScanned(printerID)">Print</button>
    </div>
</ng-template>